const Close = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_5763_8286)'>
        <path
          d='M12.6668 4.27203L11.7268 3.33203L8.00016 7.0587L4.2735 3.33203L3.3335 4.27203L7.06016 7.9987L3.3335 11.7254L4.2735 12.6654L8.00016 8.9387L11.7268 12.6654L12.6668 11.7254L8.94016 7.9987L12.6668 4.27203Z'
          fill='#F71E1E'
        />
      </g>
      <defs>
        <clipPath id='clip0_5763_8286'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Close;
